import React from 'react';
import { connect } from 'react-redux';

import './styles.scss';

const FAQ = ({ faq }) => (
  <div className="appendTop15" dangerouslySetInnerHTML={{ __html: faq }} suppressHydrationWarning />
);

const mapStateToProps = ({ seo }) => ({
  faq: seo?.metaData?.faqHTML,
});

export default connect(mapStateToProps, null)(FAQ);
